import http from '../api/http';
import fetchInstance from './fetchConfig';

export default {
    venueTargets({callback}){ // 展示本周预计的目标 (Venue Targets)
        http.post('/v1/venue/venueTargets').then(res => {
            callback(res,'login')
        }).catch(err => {
            callback(err,'login')
        })
    },
    async getTimezoneList(){
        try {
            const res = await fetchInstance(`/venue/v1/timezones`, {
                isRegistration: true
            })
            return res.json()
        } catch (error) {
            throw new Error("Failed to fetch timezone list");
        }
    },
}


// WEBPACK FOOTER //
// ./src/api/venue.js